import { gql, graphql } from "react-apollo"
import { GetUsersQuery } from "./withUsers"

const MUTATE_DELETE_USER = gql`
  mutation DeleteUser($id: ID!) {
    deleteUser(id: $id) {
      id
      email
    }
  }
`

const mutateDeleteUser = graphql(MUTATE_DELETE_USER, {
  name: "mutateDeleteUser",
  options: {
    refetchQueries: [{ query: GetUsersQuery, variables: { query: "" } }]
  },
  props: ({ mutateDeleteUser }) => ({
    deleteUser: (id: string) =>
      mutateDeleteUser({
        variables: { id }
      })
  })
})

export default mutateDeleteUser



// WEBPACK FOOTER //
// ./src/Users/queries/mutateDeleteUser.js